import { ProjectFormatResponse } from "../../api-models/response/ProjectFormatResponse";

export class ProjectFormat implements ProjectFormatResponse {
  id: string;
  name: string;
  language: string;
  readonly: boolean;

  constructor(projectFormat: ProjectFormatResponse, public isValid: boolean) {
    this.id = projectFormat.id;
    this.name = projectFormat.name;
    this.language = projectFormat.language;
    this.readonly = projectFormat.readonly;
  }
}
